/**
 * [S-3, design-conformance 05/09] Adapta um anexo PERSISTIDO
 * (`{nome, content_type, tamanho, upload_id}` — o que `anexosDaMensagem`
 * devolve, `utils/anexos-da-mensagem.js`) para o shape que
 * `composer-attachments.vue` espera (`{name, size, type, upload_id}`), a
 * MESMA anatomia que o anexo AO VIVO usa (`File.name`/`.size`/`.type`).
 *
 * Antes desta mudança a bolha desenhava o anexo AO VIVO (`message.anexos`,
 * ainda em memória) em miniatura 72×72, e o mesmo anexo REABERTO (depois do
 * F5, só com o bloco técnico persistido) num chip "📎 nome" à parte — o
 * MESMO anexo, na MESMA bolha, com duas anatomias. `chat-message.vue` agora
 * reusa `<ComposerAttachments somente-leitura>` nos dois caminhos, passando
 * por este adaptador quando o dado vem do bloco técnico.
 *
 * ★ Não é um `File`/`Blob` de verdade — não há bytes, só metadado (o backend
 * nunca reenvia o arquivo, só o registro do upload). `composer-attachments`
 * detecta isso pela chave (`chaveDoArquivo`, que prefere `upload_id` quando
 * presente — nenhum `File` real carrega esse campo) e não tenta criar object
 * URL: a miniatura degrada para o ícone do tipo (cor/borda pelo
 * `content_type`/nome), sem preview nem clique — o mesmo "sem prévia
 * possível" que já valia para documento ao vivo, agora também para imagem
 * reaberta sem bytes.
 */
export function paraItemDeAnexo(anexoPersistido) {
  if (!anexoPersistido) return null
  return {
    name: anexoPersistido.nome,
    size: anexoPersistido.tamanho,
    type: anexoPersistido.content_type,
    upload_id: anexoPersistido.upload_id,
  }
}
